import { createFileRoute } from '@tanstack/react-router'

import { UpdatesList } from '@/modules/updates'
import { fetchUpdates } from '@/modules/updates/service/changelog'
import { captureException } from '@/services/monitoring/captureException'

export const Route = createFileRoute('/_authenticated/updates/')({
  staticData: { title: 'Updates' },
  loader: async () => {
    try {
      return await fetchUpdates()
    } catch (error) {
      captureException(error as Error)
      return []
    }
  },
  component: WhatsNewPage,
})

function WhatsNewPage() {
  const updates = Route.useLoaderData()
  return <UpdatesList updates={updates} />
}
